import { TfabulousId } from "@/module/fabulous"
import request from "@/utils/requset";
export const GetItemlist = () => { }

// 添加点赞
export const getAddFabulous = (data: TfabulousId) => {
    return request<TfabulousId, boolean>({
        url: '/api/user/fabulous/addfabulous',
        method: 'POST',
        data
    })
}
// 取消点赞
export const getRemoveFabulous = (data: TfabulousId) => {
    return request<TfabulousId, boolean>({
        url: '/api/user/fabulous/cancelfabulous',
        method: 'POST',
        data
    })
}
